import React, { Component } from "react";
import "../App.css";
import "./viewer.css";
import { CSSTransition } from "react-transition-group";
class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opacity: 1
    };
  }

  changeOpacity() {}
  render() {
    const { page_image, extract_image, id } = this.props.property;
    return (
      <CSSTransition
        key={id}
        timeout={300}
        classNames="fade"
        appear={true}
        in={true}
      >
        <div key={`page-${id}`} className="page container-size">
          {page_image && (
            <img
              className="page-image img-fluid.max-width:100%"
              src={page_image}
              alt="#"
            />
          )}
          {extract_image && (
            <img
              className="extract-image  img-fluid.max-width:100% w3-grayscale-min"
              src={extract_image}
              alt=""
              style={{ opacity: this.props.opacity }}
            />
          )}
        </div>
      </CSSTransition>
    );
  }
}

export default Page;
